// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"3a62c527","149":"d0ef07df","328":"ee7684fa","785":"fef41dbb","797":"14fb4f4e","971":"dc147193"}[chunkId] + ".chunk.css";
};